import {QueryKey, useQuery, UseQueryOptions} from '@tanstack/react-query';
import {COMPANY_INTEGRATION_UPS} from 'App/data-hooks/queryKeys';
import {getUPSRegistrationAccounts} from 'App/containers/ups/actions/async';

/**
 * Get Ups status connection.
 */

export const useGetUpsQuery = (options: UseQueryOptions<unknown>) => {
  const getAmazonFreightQuery = useQuery(
    [COMPANY_INTEGRATION_UPS] as QueryKey,
    () => {
      return getUPSRegistrationAccounts();
    },
    options
  );
  return getAmazonFreightQuery.data;
};
